<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.background.color"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field hide-details v-model="fields.background.color" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field hide-details v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <div class="label-input">Title Content</div>
          </div>
          <div class="group-item mb-5">
            <v-checkbox class="mt-0" v-model="fields.showTitleContent" label="Show" />
            <ckeditor :editor="editor" v-model="fields.titleContent" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="label-input">Items Settings</div>
          <div class="group-item mb-5">
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="fields.wapperItems.contentAlign"
                  :items="['left', 'center', 'right']"
                  label="Content Align"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model.number="fields.wapperItems.colPerView"
                  :items="[2, 3, 4, 5, 6]"
                  label="Columns per view"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.wapperItems.withIcon"
                  label="With Icon (px)"
                  type="number"
                  hint="Icon width in pixels"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="d-flex justify-space-between align-center mb-3">
            <div class="label-input">Items</div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item mb-5">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.wapperItems.listItem" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="">
                    <div class="mb-5">
                      <label class="font-weight-bold">Image</label>
                      <UploadImage
                        @callback="obj => handleUploadImageItem(obj, i)"
                        :image="{ imageSrc: item.image }"
                        :height="`250`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveImageItem(i)"
                      />
                    </div>
                    <div class="mb-5">
                      <label class="font-weight-bold">Text Content</label>
                      <ckeditor :editor="editor" v-model="item.htmlText" :config="editorConfig" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'IconWithTextB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Icon With Text B1 Section',
        textColor: '#000000',
        enableAnchor: false,
        padding: {
          top: true,
          bottom: true,
        },
        background: {
          color: '',
        },
        showTitleContent: true,
        titleContent: `
          <h3 style="text-align:center;">Not All Outdoor Lights Are Created Equal</h3>
          <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti voluptatum ipsum pariatur.</p>
        `,
        wapperItems: {
          contentAlign: 'center',
          colPerView: 3,
          withIcon: 60,
          listItem: [
            {
              image: 'https://cdn.skyfastimg.com/images/2025/12/25/image-694cbe9cdc1d628b9b29178e.png?w=200',
              htmlText: `
                <h2>All-night runtime</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit</p>
              `,
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionIconWithTextB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.background.color = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleAddItem() {
      this.fields.wapperItems.listItem.push({
        image: '',
        htmlText: '',
      });
    },
    handleRemoveItem(index) {
      this.fields.wapperItems.listItem.splice(index, 1);
    },
    handleUploadImageItem(obj, index) {
      this.fields.wapperItems.listItem[index].image = obj.imageSrc;
    },
    handleRemoveImageItem(index) {
      this.fields.wapperItems.listItem[index].image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
